import axios from "axios";

let customerSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const customerAxiosInstance = axios.create({
	baseURL: customerSvc,
});

export default {
	customerService: {
		confirmCustomerData(url, customerData, token) {
			return customerAxiosInstance.put(url, customerData, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/json",
				},
			});
		},

		searchRewards(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/offers/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateReward(offer, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/offers/" + offer.id,
				offer,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updatePersonInfo(userid, person, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/users/" + userid + "/persons/" + person.id,
				person,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteUser(user, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/cms/users/" + user.id,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateUserInfo(user, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/users/" + user.id,
				user,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteRewardForCompany(offerId, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/cms/offers/" + offerId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getRewardDetails(offerId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/offers/" +
				offerId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getMessages(formData, token) {
			return customerAxiosInstance.get(
				companyRoot + "/v2/app_messages" + formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		markMessageAsRead(message, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v2/app_messages/" + message.id,
				message,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		searchCompany(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot + "/v1/cms/financiers/search" + searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		searchGames(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/missions/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getGameDetails(gameId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/missions/" +
				gameId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addNewGame(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/missions",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateGame(game, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/missions/" + game.mission_id,
				game,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		approveGame(game, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/missions/approve/" + game.mission_id,
				game,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteGame(gameId, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/cms/missions/" + gameId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// partners list
		getPartnersListFile(token) {
			return customerAxiosInstance.get(
				companyRoot + "/v1/cms/affiliates-category/download",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updatePartnersList( formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/affiliates-category/upload",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		validateImage( formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/missions/image",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// rewards
		searchRewards(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/rewards/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getRewardDetails(rewardsId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/rewards/" +
				rewardsId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addNewReward(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/rewards",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateReward(reward, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/rewards/" + reward.id,
				reward,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		approveReward(reward, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/cms/rewards/approve/" + reward.id,
				reward,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addVouchersForReward(reward, formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/rewards/" + reward.id + "/vouchers",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getOrderTemplateModelFile(token) {
			return customerAxiosInstance.get(
				companyRoot + "/v1/cms/rewards/order_files",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteReward(rewardId, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/cms/rewards/" + rewardId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// categories
		getCategories(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/categories" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// affiliates	
		getAffiliates(category, searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/affiliates/" + category + "/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// dashboard 
		getStatistics(token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/dashboard",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// dashboard 
		getLogs(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/cms/dashboard/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// push notifications
		searchCampaigns(searchParams, token) {
			return customerAxiosInstance.post(
				companyRoot +
				"/v1/plus/marketing/campaigns/search" ,
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getCampaignDetails(campaignId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/marketing/campaigns/" +
				campaignId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addNewCampaign(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/plus/marketing/campaigns",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateCampaign	(campaign, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/plus/marketing/campaigns/" + campaign.id,
				campaign,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		deleteCampaign(campaign_id, token) {
			return customerAxiosInstance.delete(
				companyRoot +  "/v1/plus/marketing/campaigns/" + campaign_id,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addNewCoinCampaign(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/cms/rewards/orders  ",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

	},
};
